import { render, staticRenderFns } from "./ActionPdfViewer.vue?vue&type=template&id=54993a78"
import script from "./ActionPdfViewer.vue?vue&type=script&lang=js"
export * from "./ActionPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./ActionPdfViewer.vue?vue&type=style&index=0&id=54993a78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports